"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZDrawOrderSchedulePlanSelect = exports.ZSubscriptionHistorySelect = exports.ZSubscriptionRunSelect = exports.ZSubscriptionSelect = void 0;
const types_1 = require("@daymade/common-lib/types");
const zod_1 = require("zod");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
exports.ZSubscriptionSelect = zodSchemas_generated_1.zodSelectSubscription
    .pick({
    id: true,
    status: true,
    playerId: true,
    orderId: true,
    paymentDow: true,
    failedAt: true,
    version: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectSubscription.shape, {
    createdAt: zod_1.z.coerce.date(),
    nextPaymentDate: zod_1.z.coerce.date(),
    cancelledAt: zod_1.z.coerce.date().nullable(),
    snoozedUntil: zod_1.z.coerce.date().nullable(),
}));
exports.ZSubscriptionRunSelect = zodSchemas_generated_1.zodSelectSubscriptionRun
    .pick({
    id: true,
    status: true,
    playerId: true,
    runNumber: true,
    drawOrderId: true,
})
    .extend({
    createdAt: zod_1.z.coerce.date(),
});
exports.ZSubscriptionHistorySelect = zodSchemas_generated_1.zodSelectSubscriptionHistory
    .pick({
    id: true,
    createdAt: true,
    action: true,
    additionalInfo: true,
})
    .extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodSelectSubscriptionHistory.shape, {
    createdAt: zod_1.z.coerce.date(),
}));
exports.ZDrawOrderSchedulePlanSelect = zodSchemas_generated_1.zodSelectDrawOrderSchedulePlan;
//# sourceMappingURL=models.js.map